var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 97,
    viewBox: "0 0 96 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.5617 51.6123C71.9299 51.6276 74.6523 54.3816 74.6523 57.7736C74.6523 61.1136 71.9445 64.0176 68.6291 64.105L63.2908 64.105C58.699 59.4808 62.0449 51.6123 68.5617 51.6123Z",
    fill: "url(#paint0_linear_3518_1468)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8848 69.2883C50.9002 72.6565 53.6764 75.3789 57.0957 75.3789C60.4626 75.3789 63.39 72.671 63.4782 69.3556L63.4782 65.2362C63.4782 65.2362 62.9301 58.1931 64.3556 55.4007C65.5424 53.0757 68.5574 51.6122 68.5574 51.6122L58.8848 51.6122C54.4665 51.6122 50.8848 55.194 50.8848 59.6122L50.8848 69.2883Z",
    fill: "#59C3FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8094 44.9072C23.4412 44.892 20.7188 42.1379 20.7188 38.7459C20.7188 35.406 23.4266 32.502 26.742 32.4145L32.0803 32.4145C36.6721 37.0388 33.3262 44.9072 26.8094 44.9072Z",
    fill: "url(#paint1_linear_3518_1468)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4863 27.536C44.4712 24.1678 41.7428 21.4453 38.3825 21.4453C35.0736 21.4453 32.1967 24.1532 32.11 27.4686V32.5021C32.11 32.5021 32.6486 38.3264 31.2478 41.1188C30.0814 43.4439 27.1184 44.9073 27.1184 44.9073L36.4863 44.9073C40.9046 44.9073 44.4863 41.3256 44.4863 36.9073V27.536Z",
    fill: "#59C3FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4082 69.3982C44.3931 72.7455 41.6753 75.4512 38.3279 75.4512C35.0318 75.4512 32.166 72.76 32.0797 69.4651L32.0797 64.1674C36.6292 59.6179 44.4082 62.9641 44.4082 69.3982Z",
    fill: "url(#paint2_linear_3518_1468)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8094 51.6113C23.4412 51.6267 20.7188 54.4029 20.7188 57.8223C20.7188 61.1892 23.4266 64.1166 26.742 64.2047L32.0803 64.2047C32.0803 64.2047 37.9045 63.6567 40.697 65.0821C43.022 66.269 44.4854 69.284 44.4854 69.284L44.4854 59.6113C44.4854 55.1931 40.9037 51.6113 36.4854 51.6113L26.8094 51.6113Z",
    fill: "#257CFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0195 27.4104C51.0346 24.0631 53.7524 21.3574 57.0998 21.3574C60.3959 21.3574 63.2617 24.0486 63.3481 27.3435L63.3481 32.6412C58.7985 37.1907 51.0195 33.8444 51.0195 27.4104Z",
    fill: "url(#paint3_linear_3518_1468)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6183 45.1973C71.9865 45.1819 74.709 42.4057 74.709 38.9863C74.709 35.6194 72.0011 32.692 68.6857 32.6039L63.3475 32.6039C63.3475 32.6039 57.5232 33.1519 54.7308 31.7265C52.4057 30.5396 50.9423 27.5246 50.9423 27.5246L50.9423 37.1973C50.9423 41.6155 54.524 45.1973 58.9423 45.1973L68.6183 45.1973Z",
    fill: "#257CFF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3518_1468",
    x1: 75.9589,
    y1: 55.8905,
    x2: 52.3161,
    y2: 63.9702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59C3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCF2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3518_1468",
    x1: 19.4122,
    y1: 40.6291,
    x2: 43.055,
    y2: 32.5493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59C3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCF2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3518_1468",
    x1: 40.1863,
    y1: 76.7493,
    x2: 32.1163,
    y2: 53.2932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#257CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFE2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3518_1468",
    x1: 55.2415,
    y1: 20.0593,
    x2: 63.3114,
    y2: 43.5154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#257CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFE2FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo-icon.22c93aed29139e2aec61f5cef8ba61ca.svg";
export { ForwardRef as ReactComponent };